import _from from './from';
import _to from './to';
export class vKlassMap {
  static from = _from;
  static to = _to;
}
